export default "__VITE_ASSET__DsncBel5__"